/** Mirror of backend functionMode/naming.js for admin preview. */

const splitParts = (name) =>
  String(name || '')
    .trim()
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
    .replace(/[-\s]+/g, '_')
    .split('_')
    .filter(Boolean)
    .map((p) => p.toLowerCase());

export const toCamelCase = (name) => {
  const parts = splitParts(name);
  if (!parts.length) return '';
  return parts
    .map((p, i) => (i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1)))
    .join('');
};

export const toPascalCase = (name) => {
  const parts = splitParts(name);
  return parts.map((p) => p.charAt(0).toUpperCase() + p.slice(1)).join('');
};

export const toSnakeCase = (name) => splitParts(name).join('_');

export const identifierForLanguage = (canonical, kind, language) => {
  const raw = String(canonical || '').trim();
  if (!raw) return raw;

  switch (language) {
    case 'python':
      if (kind === 'class') return toPascalCase(raw);
      return toSnakeCase(raw);
    case 'csharp':
      if (kind === 'param') return toCamelCase(raw);
      return toPascalCase(raw);
    case 'javascript':
    case 'java':
    case 'cpp':
    default:
      if (kind === 'class') return toPascalCase(raw);
      return toCamelCase(raw);
  }
};

export const localizeSignature = (signature, language) => ({
  ...signature,
  className: identifierForLanguage(signature?.className || 'Solution', 'class', language),
  methodName: identifierForLanguage(signature?.methodName, 'method', language),
  params: (signature?.params || []).map((p) => ({
    ...p,
    name: identifierForLanguage(p.name, 'param', language),
  })),
});

export const formatSignatureLine = (signature, language) => {
  if (!signature?.methodName) return null;
  const loc = localizeSignature(signature, language);
  const params = (loc.params || [])
    .map((p) => `${p.type || '?'} ${p.name || '?'}`)
    .join(', ');
  const ret = String(signature.returnType || '').toLowerCase() === 'void'
    ? 'void'
    : signature.returnType || '?';
  return `${ret} ${loc.className}.${loc.methodName}(${params})`;
};
